<template>
    <div class="mr-3">
        <button type="button" :class="['btn btnclass smallerfontsize', addSelectedClass]" @click="fieldData.showTargetGroupModal = true">
            Target / Metric
        </button>
        <b-modal
            @ok="saveTargetToLocalStorage"
            v-model="fieldData.showTargetGroupModal"
            @show="showModal"
            @hide="onHidden"
            :no-close-on-backdrop="true"
            id="modal-target"
            dialog-class="targetgroupmodal"
            title="Select target group / metric"
        >
            <b-toast id="targetGroupExist" title="Warning" variant="warning" :solid="true" auto-hide-delay="3000">
                <span v-html="targetToastWarningMsg"> </span>
            </b-toast>
            <div class="form-row">
                <div v-for="(select, index) in selects" :key="index" :class="select.class">
                    <label>
                        {{ select.label }}
                        <div>
                            <b-form-select :disabled="select.disabled" size="sm" :options="select.options" v-model="select.value" @change="clickedSelect(select)"></b-form-select>
                        </div>
                    </label>
                </div>
                <b-form-group v-if="config_ShowModelSelection">
                    <b-form-checkbox-group v-model="selectedSources" :options="sources" class="px-2 mt-3"></b-form-checkbox-group>
                    <span class="ml-1" v-show="showTvOnlineExplanation" style="font-size: 0.75rem"
                        >TV and online data are components for calculating the total, not exactly the same as the values for TV and online video.</span
                    >
                </b-form-group>
                <div class="col-sm-12 mt-2 mb-2">
                    <b-button class="mr-2" variant="success" size="sm" @click="saveTarget"> Add </b-button>
                    <b-button v-if="targetGroups.length > 1" variant="danger" size="sm" @click="removeTargets"> Remove all </b-button>
                </div>

                <b-list-group class="mt-3 w-100">
                    <b-list-group-item class="targetgroup-list-item" v-for="(targetGroup, index) in targetGroups" :key="index">
                        <span class="targetgroup-text" v-html="stringifyTarget(targetGroup, true)"> </span>
                        <b-button class="mr-2 float-right" variant="danger" size="sm" @click="removeTarget(index)"> Remove </b-button>
                    </b-list-group-item>
                </b-list-group>
            </div>
            <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()"> Cancel </b-button>
                <b-button size="sm" variant="primary" @click="ok()"> Save </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import formSelects from "./formSelectsAd"
import props from "@/mixins/inputProps"
import globalConfig from "../../../../mixins/globalConfig"
export default {
    name: "TargetGroupAds",
    mixins: [props, globalConfig],
    props: {
        fieldData: Object,
    },
    data() {
        return {
            selects: formSelects(this.$props.fieldData.config),
            currentTargetGroups: null,
            closeWithoutSaving: false,
            selectedSources: ["Total"],
            sources: [
                { text: "(tv-data)", value: "Tv" },
                { text: "(online-data)", value: "Online" },
                { text: "Total", value: "Total" },
            ],
            targetToastWarningMsg: "",
            showTvOnlineExplanation: false,
            unsavedTargets: [],
        }
    },
    async mounted() {
        this.setTargetGroupsFromLocalStorage()
        this.currentTargetGroups = this.$store.getters[this.getter].target_groups
        await this.loadGlobalConfigFromFile()
        this.setAvailableSelections()
        if (!this.config_EnableSexAd) {
            this.selects = this.selects.map(obj => {
                if (obj.identifier === "group") {
                    obj.options = obj.options.filter(opt => {
                        if (opt.text === "Alla") return opt
                    })
                }
                return obj
            })
        }
    },
    watch: {
        selectedSources(sources) {
            this.showTvOnlineExplanation = sources.includes("Online") || sources.includes("Tv") ? true : false
        },
    },
    computed: {
        targetGroups() {
            return this.unsavedTargets ? this.unsavedTargets : []
        },
        addSelectedClass() {
            let adThisClass = ""
            if (this.getTargetGroupCount() > 0) adThisClass = "selected"
            return adThisClass
        },
    },
    methods: {
        onHidden() {
            document.removeEventListener("keyup", this.onKeyUp)
        },
        onKeyUp(event) {
            if (event.key === "Enter" && this.fieldData.showTargetGroupModal) {
                this.saveTargetToLocalStorage()
                this.fieldData.showTargetGroupModal = false
            }
        },
        getTargetGroupCount() {
            let storedTargets = this.$store.getters[this.getter][this.fieldData.identifier]

            return storedTargets != null ? storedTargets.length : 0
        },
        showModal() {
            document.addEventListener("keyup", this.onKeyUp)
            this.setTargetGroupsFromLocalStorage()
        },
        setTargetGroupsFromLocalStorage() {
            this.unsavedTargets = [...this.$store.getters[this.getter][this.fieldData.identifier]]
        },
        saveTargetToLocalStorage() {
            const updatedQuery = {
                ...this.$store.getters[this.getter],
                [this.fieldData.identifier]: [...this.unsavedTargets],
            }
            this.$store.commit(this.setter, updatedQuery)
        },
        sortSelectedSources(sources) {
            this.selectedSources.sort((a, b) => sources.indexOf(a) - sources.indexOf(b))
        },
        saveTarget() {
            document.activeElement.blur()
            let maxTargetGroupCount
            if (Number.isInteger(this.config_NumberOfTargetGroupsAd)) maxTargetGroupCount = this.config_NumberOfTargetGroupsAd
            else maxTargetGroupCount = 6
            if (this.targetGroups.length + this.selectedSources.length > maxTargetGroupCount) {
                this.$bvToast.toast(`Maximum number of target groups is ${maxTargetGroupCount}`, {
                    title: "Warning",
                    variant: "warning",
                    solid: true,
                    autoHideDelay: 3000,
                })
                return
            }
            let query = {}

            this.selects.map(function(select) {
                if (select.identifier === "consolidation") {
                    let consolidationObj = this.selects.find(s => s.identifier == "consolidation")
                    query[select.identifier] = consolidationObj.options.find(co => co.value == select.value)
                } else query[select.identifier] = select.value
            }, this)
            this.sortSelectedSources(this.sources.map(s => s.value))
            let updatedTargets = this.unsavedTargets

            for (let i = 0; i < this.selectedSources.length; i++) {
                query.source = this.selectedSources[i]
                query.selectedMeasureText = this.stringifyTarget(query)
                //check if measure is already added
                let targetGroupStrings = updatedTargets.map(t => t.selectedMeasureText.header + t.selectedMeasureText.subHeader)
                if (targetGroupStrings.includes(query.selectedMeasureText.header + query.selectedMeasureText.subHeader)) {
                    this.$bvToast.toast(`Target group ${query.selectedMeasureText.header + " " + query.selectedMeasureText.subHeader} already exists`, {
                        title: "Warning",
                        variant: "warning",
                        solid: true,
                    })
                    continue
                }
                updatedTargets.push({ ...query })
            }
        },
        removeTarget(index) {
            this.unsavedTargets.splice(index, 1)
        },
        removeTargets() {
            this.unsavedTargets = []
        },
        stringifyTarget(targetGroup, isVHtml = false) {
            let measureText = {}
            measureText.header = this.fieldData.config.measures.find(x => x.value == targetGroup.measure).selectedText
            let ageGroup = this.selects.find(s => s.identifier == "group").options.find(o => o.value == targetGroup.group).selectedAgeGroupText
            let reachTvAndOnlineText = ""
            if (targetGroup.measure.includes("reach")) {
                let selectedMeasureReachTv = this.selects.find(s => s.identifier == "reach_tv").options.find(o => o.value == targetGroup.reach_tv).selectedReachTvText
                let selectedMeasureReachOnline = this.selects.find(s => s.identifier == "reach_online").options.find(o => o.value == targetGroup.reach_online).selectedReachOnlineText
                reachTvAndOnlineText = `(${selectedMeasureReachTv} & ${selectedMeasureReachOnline}) `
            }
            let sourceText = this.sources.find(s => s.value == targetGroup.source).text
            measureText.subHeader = `${ageGroup}${targetGroup.age_from}-${targetGroup.age_to} ${reachTvAndOnlineText}${sourceText}`
            if (isVHtml) {
                return `${measureText.header} <span class="measureagewrapper">${measureText.subHeader}</span>`
            }
            return measureText
        },
        clickedSelect(select) {
            if (select.identifier == "age_from" || select.identifier == "age_to") {
                let ageToSelect = this.selects.find(select => select.identifier == "age_to")
                let ageFromSelect = this.selects.find(select => select.identifier == "age_from")
                if (parseInt(ageFromSelect.value) > parseInt(ageToSelect.value)) {
                    if (select.identifier == "age_from") {
                        let newToSelect = ""
                        ageToSelect.options.forEach(e => {
                            if (newToSelect == "" && parseInt(e.value) > parseInt(ageFromSelect.value)) {
                                newToSelect = e.value
                            }
                        })
                        ageToSelect.value = newToSelect
                    } else {
                        let newFromSelect = ""
                        ageFromSelect.options.forEach(el => {
                            if (parseInt(ageToSelect.value) > parseInt(el.value)) {
                                newFromSelect = el.value
                            }
                        })
                        ageFromSelect.value = newFromSelect
                    }
                }
            } else if (select.identifier == "measure") {
                let reachTv = this.selects.find(select => select.identifier == "reach_tv")
                let reachOnline = this.selects.find(select => select.identifier == "reach_online")
                let disableReachCriteria = false
                if (!select.value.includes("reach")) disableReachCriteria = true
                reachTv.disabled = disableReachCriteria
                reachOnline.disabled = disableReachCriteria
                this.setAvailableSelections()
            }
        },
        setAvailableSelections() {
            if (this.config_EnableAgeLimitedOnAdMeasures) {
                this.setAvailableAgeGroups(["3", "15", "30", "45", "60"], ["14", "29", "44", "59", "99"])
            } else {
                this.setAvailableAgeGroups()
            }
        },
        setAvailableAgeGroups(agesFrom, agesTo) {
            const all_age_from = formSelects(this.$props.fieldData.config).find(obj => {
                return obj.identifier === "age_from"
            })
            const ageFromIndex = this.selects.findIndex(obj => {
                return obj.identifier == "age_from"
            })
            const all_age_to = formSelects(this.$props.fieldData.config).find(obj => {
                return obj.identifier === "age_to"
            })
            const ageToIndex = this.selects.findIndex(obj => {
                return obj.identifier == "age_to"
            })
            //update available age options
            if (agesFrom?.length) {
                this.selects[ageFromIndex].options = all_age_from.options.filter(age => {
                    return agesFrom.includes(age.text)
                })
            } else {
                this.selects[ageFromIndex].options = all_age_from.options
            }
            if (agesTo?.length) {
                this.selects[ageToIndex].options = all_age_to.options.filter(age => {
                    return agesTo.includes(age.text)
                })
            } else {
                this.selects[ageToIndex].options = all_age_to.options
            }

            //set disabled state
            this.selects[ageFromIndex].disabled = this.selects[ageFromIndex].options.length == 1 ? true : false
            this.selects[ageToIndex].disabled = this.selects[ageToIndex].options.length == 1 ? true : false

            //update values in UI
            this.selects[ageFromIndex].value = this.selects[ageFromIndex].options[0].value
            this.selects[ageToIndex].value = this.selects[ageToIndex].options[this.selects[ageToIndex].options.length - 1].value
        },
    },
}
</script>

<style>
.custom-control-label {
    display: inline-flex;
    align-items: center;
}
</style>
<style scoped>
.targetgroup .measureagewrapper {
    font-size: 0.8rem;
}
label {
    width: 100%;
}
.form-selects label div {
    margin-top: 5.6px;
}

.selectedItemsClass {
    background-color: #e5f3ff;
    border-color: #337ab7;
    color: #6c757d;
}
</style>
